// Function loadSiteFooterSitemap loads the SiteFooterSitemap class by dynamically importing the js on demand if needed

export function loadSiteFooterSitemap($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-site-footer-sitemap-chunk" */ '../widgets/siteFooterSitemap').then(wg => {

		const { SiteFooterSitemap } = wg;

		let $wg = $parentEl.querySelector('[data-wg="SiteFooterSitemap"]');

		if(!$wg) {
			// console.info('SiteFooterSitemap: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="SiteFooterSitemap"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new SiteFooterSitemap($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new SiteFooterSitemap($wg);
		}


	}).catch(error => error+'An error occurred while loading the SiteFooterSitemap widget');

}
